import useFetchApi, { FetchingStatus } from 'hooks/useFetchApi/useFetchApi'
import licenseService from 'Services/api/license.service'

function useLicenseRenew() {
    const [renewLicenseResult, renewLicense, renewLicenseStatus] = useFetchApi(
        licenseService.renewLicense,
    )

    return {
        processing: renewLicenseStatus === FetchingStatus.LOADING,
        renewLicense,
        renewLicenseResult,
    }
}

export default useLicenseRenew
